export default __webpack_public_path__ + "static/saiku-ce4c0e2129f925875295b416226de185.png";